/**
 * The statuses an approved application moves through while its approvals are being renewed or extended. Mirrors
 * `RENEWAL_APPLICATION_STATUSES` in the CMS (`helpers/renewalStatus.ts`), which owns the transitions.
 */
export const RENEWAL_APP_STATUSES: EnumApplicationStatus[] = [
  "approval_expires",
  "renewal_required",
  "renewal_submitted",
  "renewal_approved",
  "extension_required",
  "extension_submitted",
  "extension_approved",
]

/** Approved, or approved and now in the renewal cycle - the application's own approval stands in all of them. */
export const ISSUED_APP_STATUSES: EnumApplicationStatus[] = ["approved", ...RENEWAL_APP_STATUSES]

/**
 * Statuses before `submitted`, in workflow order. Mirrors `NOT_SUBMITTED_APP_STATUSES` in the CMS
 * (`helpers/removalRules.ts`), which decides who may delete approval items with it.
 */
export const NOT_SUBMITTED_APP_STATUSES: EnumApplicationStatus[] = [
  "created",
  "quote_issued",
  "proof_of_payment_required",
  "unpaid",
  "invoice_created",
  "confirmed",
  "payment_requested",
  "outstanding_documents",
  "ready_for_submitting",
  "in_review",
  "reviewed",
]

export const isIssuedAppStatus =(status: Maybe<string>): boolean =>
  ISSUED_APP_STATUSES.includes(status as EnumApplicationStatus)
